export default "__VITE_ASSET__MNFm4nRx__"